/* Look Around Apps */

// Thumb Menu

const thumbBtn = document.querySelector("button.site-nav__thumb-button.js-toggle-slide-nav");
// const thumbCart = document.querySelector("a.site-nav__thumb-cart");

// thumbBtn.addEventListener('click', () => {
//   setTimeout(() => {             
//     if (thumbBtn.classList.contains("is-active")){
// 		return thumbCart?.style.display = 'none';
// 	}
// 	thumbCart?.style.display = 'flex';
//   }, 10)
// });

// Load Store Pickup + Delivery on quantity change
document.addEventListener("cart:updated", function(e) {
	if (window.Zapiet && window.ZapietCachedSettings) {
	  Zapiet.start(ZapietCachedSettings);
	}
}); 
